import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon, LockIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-12 pb-20 px-4 overflow-hidden" data-id="element-107">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand-pink/10 blur-[120px] rounded-full pointer-events-none" data-id="element-108" />

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-110">
          <h1 className="text-4xl md:text-6xl lg:text-7xl text-white leading-[0.95]" data-id="element-111">
            TODO TU AÑO DE ENTRENAMIENTO{' '}
            <span className="text-brand-pink" data-id="element-112">HYROX RESUELTO</span>
          </h1>
        </motion.div>

        {/* Main mockup — 70% size, placed between headline and subtitle */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.15
      }} className="relative mx-auto w-[70%] max-w-2xl my-8 rounded-2xl overflow-hidden border border-gray-800 shadow-2xl" data-id="element-113">
          <div className="absolute inset-0 bg-gradient-to-t from-brand-black via-transparent to-transparent z-10" data-id="element-114" />
          <img src="https://cdn.magicpatterns.com/uploads/sZDkAVmFfBTH5r6W6pmu7s/ChatGPT_Image_2_jun_2026,_04_55_34_p.m..png" alt="Pack HYROX Imparable" fetchPriority="high" decoding="async" width={1232} height={1232} className="w-full h-auto object-cover" data-id="element-115" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} data-id="element-116">
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-117">
            Tu plan completo para volver a entrenar y llegar a tu primera
            carrera HYROX: reconexión, fuerza, resultados y planificación.{' '}
            <strong className="text-white font-semibold" data-id="element-118">
              Sin abandonar a la semana.
            </strong>
          </p>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-10" data-id="element-119">
            <div className="flex items-center gap-2 text-sm text-gray-300 bg-brand-dark px-4 py-2 rounded-lg border border-gray-800" data-id="element-120">
              <FileTextIcon className="w-4 h-4 text-brand-pink" data-id="element-121" />
              <span data-id="element-122">PDF Digital</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-300 bg-brand-dark px-4 py-2 rounded-lg border border-gray-800" data-id="element-123">
              <ZapIcon className="w-4 h-4 text-brand-pink" data-id="element-124" />
              <span data-id="element-125">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-300 bg-brand-dark px-4 py-2 rounded-lg border border-gray-800" data-id="element-126">
              <span className="w-2 h-2 rounded-full bg-brand-pink" data-id="element-127" />
              <span data-id="element-128">Principiante - Intermedia</span>
            </div>
          </div>

          <a href="#pricing" className="inline-flex items-center justify-center w-full md:w-auto bg-brand-pink text-white font-display text-xl md:text-2xl px-8 py-5 rounded-xl hover:bg-brand-pink/90 transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(255,59,92,0.3)]" data-id="element-129">
            💥 QUIERO MI HYROX IMPARABLE AHORA
          </a>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 mt-6 text-sm text-gray-400" data-id="element-130">
            <div className="flex items-center gap-1.5" data-id="element-131">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-132" />
              <span data-id="element-133">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-134">
              <LockIcon className="w-4 h-4" data-id="element-135" />
              <span data-id="element-136">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-137">
              <CreditCardIcon className="w-4 h-4" data-id="element-138" />
              <span data-id="element-139">Mercado Pago</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}